import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppMeta } from "hooks";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";


import { useAddWarehousingMutation } from "store/services/warehousingApi";
import WarehousingForm from "./WarehousingComponents/WarehousingForm";

const WarehousingCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Warehousing", path: "/app/crm/warehousing/list" },
    { title: "New Warehousing" },
  ];

  const [createWarehousing, { isLoading: creatingWarehousing }] = useAddWarehousingMutation();

  const handleAddWarehousing = async (data) => {
    try {
      const { _id } = await createWarehousing(data).unwrap();
      toast.success("Warehousing Created!");
      navigate(`/app/crm/warehousing/${_id}/detail`);
    } catch (error) {
      toast.error(
        error?.data?.message ?? error.message ?? "Could not create Warehousing!"
      );
    }
  };

  useAppMeta("New Warehousing");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingWarehousing}>
      <BreadcrumbLayout.Paper>
        <WarehousingForm
          isBusy={creatingWarehousing}
          onSubmit={handleAddWarehousing}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default WarehousingCreateScreen;
